module.exports = __webpack_public_path__ + "media/images/header-logo-2a81afa8a2eb8c20956940a0f145ef11.svg";